type PlanDesignElementProps = {
  title: string;
  value: string | React.ReactNode;
};

export const PlanDesignElement = ({ title, value }: PlanDesignElementProps) => {
  return (
    <div className="flex w-[200px] flex-col gap-2">
      <div className="text-sm font-medium text-secondary">{title}</div>
      <div className="text-sm text-primary">{value}</div>
    </div>
  );
};
